<template>
  <header class="site-header">
    <div class="site-frame header-inner">
      <router-link
        class="brand"
        to="/home"
        @click.native="menuOpen = false"
        aria-label="Prometheus home"
      >
        <img
          class="brand-mark"
          src="@/assets/brand/prometheus-mark.png"
          alt=""
        />
        <span class="brand-type"
          ><strong>PROMETHEUS</strong><small>DISCORD BOT</small></span
        >
      </router-link>
      <button
        class="menu-toggle"
        type="button"
        :aria-expanded="String(menuOpen)"
        aria-controls="primary-nav"
        :aria-label="menuOpen ? 'Close navigation' : 'Open navigation'"
        @click="menuOpen = !menuOpen"
      >
        <X v-if="menuOpen" :size="22" aria-hidden="true" /><Menu
          v-else
          :size="22"
          aria-hidden="true"
        />
      </button>
      <nav
        id="primary-nav"
        class="primary-nav"
        :class="{ 'is-open': menuOpen }"
        aria-label="Primary navigation"
      >
        <router-link
          v-for="link in links"
          :key="link.to"
          :to="link.to"
          @click.native="menuOpen = false"
          >{{ link.label }}</router-link
        >
        <button
          class="theme-toggle"
          type="button"
          :aria-label="
            darkMode ? 'Switch to light mode' : 'Switch to dark mode'
          "
          :title="darkMode ? 'Switch to light mode' : 'Switch to dark mode'"
          @click="toggleTheme"
        >
          <Sun v-if="darkMode" :size="18" aria-hidden="true" />
          <Moon v-else :size="18" aria-hidden="true" />
          <span>{{ darkMode ? "Light mode" : "Dark mode" }}</span>
        </button>
      </nav>
    </div>
  </header>
</template>

<script>
import { Menu, Moon, Sun, X } from "lucide-vue";

export default {
  name: "Navbar",
  components: { Menu, Moon, Sun, X },
  data() {
    return {
      menuOpen: false,
      links: [
        { to: "/home", label: "Home" },
        { to: "/travel", label: "Foreign stocks" },
        { to: "/npc-loot", label: "NPC loot" },
        { to: "/api-reference", label: "API" },
        { to: "/commands", label: "Bot commands" },
        { to: "/join", label: "Discord" },
      ],
    };
  },
  computed: {
    darkMode() {
      return this.$store.state.darkMode;
    },
  },
  methods: {
    toggleTheme() {
      this.$store.commit("changeDarkMode", !this.darkMode);
    },
  },
};
</script>
